import get from 'lodash/get';

export const STORE_FAKE_AUTH = 'STORE_FAKE_AUTH';
export const CLEAR_FAKE_AUTH = 'CLEAR_FAKE_AUTH';

export function storeFakeAuthData(data) {
  const pwdLength = get(data.password, 'length');
  const fakePwd = pwdLength ? '*'.repeat(pwdLength) : undefined;
  const meta = {
    ...data,
    password: fakePwd,
  };
  return {
    type: STORE_FAKE_AUTH,
    meta,
  };
}

export function clearFakeAuthData() {
  return {
    type: CLEAR_FAKE_AUTH,
  };
}
